module.exports = __webpack_public_path__ + "static/img/dead_land.1901fac9.png";